import { createSlice } from "@reduxjs/toolkit";
import { getListPointMechanisms } from "../../api/pointMechanisms/pointMechanisms";

// giá trị khởi tạo của state
const initialState = {
  listPointMechanisms: [],
  isLoadPointMechanisms: false,
  currentPage: 1,
  pageSize: 10,
  // hasFetchedData: false,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API  
};

const pointMechanismsSlice = createSlice({
  name: "pointMechanisms", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    // setHasFetchedData: (state, action) => {
    //   state.hasFetchedData = action.payload;
    // },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListPointMechanisms.pending, (state) => {// api đnag pending chờ xử lý
        state.isLoadPointMechanisms = true;
        state.error = null;
      })
      .addCase(getListPointMechanisms.fulfilled, (state, action) => {// api trả về thành công thì trả ra
        state.isLoadPointMechanisms = false;
        state.listPointMechanisms = action.payload.data || [];

        state.isLoadPointMechanisms = false;
        // state.hasFetchedData = true;
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListPointMechanisms.rejected, (state, action) => {// api trả về thất bại thì trả ra
        state.isLoadPointMechanisms = false;
        state.error = action.payload;
      });
  },
});

// export const { setCurrentPage, setPageSize, setHasFetchedData } = pointMechanismsSlice.actions;
export const { setCurrentPage, setPageSize, setTotalRecords } = pointMechanismsSlice.actions;
export default pointMechanismsSlice.reducer;
